<template>
  <div>
    <b-col>
      <div class="row">
        <div class="col-sm-8">&nbsp;</div>
        <div class="col-sm-4 text-right">
          <button
            class="btn btn-sm btn-success"
            type="button"
            @click="addCaution()"
            :disabled="!CREATE"
          >
            Añadir Medida cautelar
          </button>
        </div>
      </div>
    </b-col>

    <section class="proj-page-section comments">
      <section
        class="without"
        v-if="!lstCautions.length > 0"
        style="margin-top: 0px"
      >
        <div class="row">
          <figure class="text-center">
            <img src="img/sin_datos.png" alt width="150px" />
          </figure>
        </div>
        <div class="row">
          <div class="col-md-12 text-center">
            <h1>Oops!</h1>
            <h4>
              No hay medidas cautelares
              <br />en este deudor.
            </h4>
          </div>
        </div>
      </section>

      <section v-else class="mt-2">
        <b-table
          :hover="true"
          :striped="true"
          :bordered="false"
          :small="false"
          :fixed="false"
          responsive="sm"
          :items="lstCautions"
          :fields="fields"
          :select-mode="'single'"
          selectable
          @row-selected="onRowSelected"
        >
          <template slot="date" slot-scope="data">{{
            formatDate(data.item.date)
          }}</template>

          <template slot="created_at" slot-scope="data">{{
            formatDate(data.item.created_at)
          }}</template>

          <template slot="actions" slot-scope="data">
          <!-- <template v-slot:cell(actions)="data"> -->
            <b-button
              size="sm"
              variant="primary"
              class="mr-1"
              title="ver"
              @click="viewCaution(data.item)"
              :disabled="!READ"
            >
              <i class="fa fa-eye"></i>
            </b-button>

            <b-button
              size="sm"
              variant="success"
              class="mr-1"
              title="Editar"
              @click="editCaution(data.item)"
              :disabled="!UPDATE"
            >
              <i class="fa fa-edit"></i>
            </b-button>

            <b-button
              size="sm"
              variant="danger"
              @click="deleteCaution(data.item)"
              title="Eliminar"
              :disabled="!DELETE"
            >
              <i class="fa fa-trash"></i>
            </b-button>
          </template>
        </b-table>
                
        <pagination
          class="mb-0"
          :data="laravelData"
          @pagination-change-page="getCautions"
          :limit="10"
          :show-disabled="true"
          :size="'small'"
          :align="'right'"
        >
          <span slot="prev-nav">Anterior</span>
          <span slot="next-nav">Siguiente</span>
        </pagination>
      </section>
    </section>

    <!-- INICIO DETALLES DE LA MEDIDA CAUTELAR -->
    <div v-if="cautionSelected && cautionSelected.id">
      <p class="mb-1">
        <strong>GESTIONES MEDIDA CAUTELAR - # {{ cautionSelected.id }}</strong>
      </p>
      <hr class="p-0 mt-0" />

      <form class="box-typical">
        <textarea
          type="text"
          class="write-something"
          rows="3"
          :placeholder="`- Ingresa tu gestión`"
          v-model="management.management"
        ></textarea>

        <div class="box-typical-footer">
          <div class="tbl">
            <div class="tbl-row">
              <b-row>
                <b-col sm="4">
                  <b-form-group>
                    <date-picker
                      id="txtFecha"
                      name="date"
                      v-model="management.date"
                      :config="options"
                      placeholder="Fecha"
                    ></date-picker>
                  </b-form-group>
                </b-col>

                <b-col sm="2">
                  <b-form-group>
                    <button
                      type="button"
                      class="btn btn-success"
                      @click="saveManagement()"
                    >
                      Enviar
                    </button>
                  </b-form-group>
                </b-col>
              </b-row>
            </div>
          </div>
        </div>
      </form>

      <section class="proj-page-section comments">
        <section
          class="without"
          v-if="!lstManagements.length > 0"
          style="margin-top: 0px"
        >
          <div class="row">
            <figure class="text-center">
              <img src="img/sin_gestion.png" alt width="210px" />
            </figure>
          </div>
          <div class="row">
            <div class="col-md-12 text-center">
              <h1>Oops!</h1>
              <h4>
                No hay gestiones
                <br />en esta medida cautelar.
              </h4>
            </div>
          </div>
        </section>

        <div class="comments" v-if="READ && lstManagements.length > 0">
          <section
            class="box-typical comment box-typical-custom"
            v-for="item in lstManagements"
            :key="item.id"
          >
            <div class="row">
              <div class="col-sm-2 mr-0">
                <div class="row">
                  <div class="col-md-12 text-center">
                    <strong>
                      <p class="mb-2">CREADA POR</p>
                    </strong>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12 text-center">
                    <img
                      v-if="item.user_image === null"
                      src="img/avatars/avatar-2-64.png"
                      class="rounded-circle"
                    />
                    <img
                      v-else
                      :src="item.user_image"
                      class="rounded-circle img-gestion"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12 text-center mt-2">
                    <p>{{ item.user_name }}</p>
                  </div>
                </div>
              </div>
              <div class="col-sm-10">
                <div class="row">
                  <div class="col-sm-9"></div>
                  <div class="col-sm-3 text-right mb-2 pr-0">
                    <b-button
                      size="sm"
                      variant="info"
                      class="mr-1"
                      title="Editar"
                      @click="editManagement(item)"
                      v-if="UPDATE"
                    >
                      <i class="fa fa-edit"></i>
                    </b-button>

                    <b-button
                      size="sm"
                      variant="danger"
                      title="Eliminar"
                      @click="deleteManagement(item)"
                      v-if="DELETE"
                    >
                      <i class="fa fa-trash"></i>
                    </b-button>
                  </div>
                </div>

                <div class="row">
                  <div class="col">
                    <p class="mb-1">
                      <strong># MEDIDA CAUTELAR</strong>
                    </p>
                    <p>{{ item.id }}</p>
                  </div>

                  <div class="col">
                    <p class="mb-1">
                      <strong>FECHA</strong>
                    </p>
                    <p>{{ formatDate(item.date) }}</p>
                  </div>
                </div>
                <hr />

                <div class="row">
                  <div class="col">
                    <p class="mb-1">
                      <strong>COMENTARIOS</strong>
                    </p>
                    <p class="text-justify">{{ item.management }}</p>
                  </div>
                </div>

                <div class="row row-footer" v-if="role_id != 6">
                  <div class="w100 text-right mr-2 mt-2">
                    <p>
                      <i class="fa fa-clock-o"></i>
                      Creada el &nbsp;{{ item.created_at }}
                      <i class="fa fa-clock-o ml-2"></i>
                      Actualizada el &nbsp;{{ item.updated_at }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <pagination
            class="mb-0"
            :data="laravelDataManagements"
            @pagination-change-page="getManagements"
            :limit="5"
            :show-disabled="true"
            :size="'small'"
            :align="'right'"
          >
            <span slot="prev-nav">Anterior</span>
            <span slot="next-nav">Siguiente</span>
          </pagination>
        </div>
      </section>
    </div>

    <!-- FIN DETALLES DE LA MEDIDA CAUTELAR -->

    <!-- MODAL PARA EL FORMULARIO -->
    <div class="modal fade" id="dlgCaution">
      <div class="modal-dialog modal-dialog-centered modal-success modal">
        <div class="modal-content">
          <!-- Modal Header -->
          <div class="modal-header">
            <h4 class="modal-title">MEDIDA CAUTELAR</h4>
            <button type="button" class="close" @click="closeCaution()">
              &times;
            </button>
          </div>

          <!-- Modal body -->
          <div class="modal-body">
            <form
              @submit.prevent="saveCaution()"
              method="post"
              v-if="caution.debtor_id"
              enctype="multipart/form-data"
            >
              <b-row>
                <b-col cols="11" sm="11" class="center-block">
                  <b-row>
                    <b-col sm="12" v-if="errores.length">
                      <b-alert show variant="danger">
                        <b>Por favor corrige los siguientes errores:</b>
                        <ul>
                          <li v-for="(error, index) in errores" :key="index">
                            {{ error }}
                          </li>
                        </ul>
                      </b-alert>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col sm="12">
                      <b-form-group>
                        <label for="txtFechaEstudio">Nombre</label>
                        <b-form-input
                          type="text"
                          id="txtNombreMedica"
                          v-model="caution.caution_name"
                          :disabled="disabledCaution"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col sm="12">
                      <b-form-group>
                        <label for="cmbTipo">Demanda</label>
                        <b-form-select
                          v-model="caution.demand_id"
                          id="cmbTipo"
                          :disabled="disabledCaution"
                        >
                          <template slot="first">
                            <option :value="null" disabled>
                              -- Seleccione el tipo --
                            </option>
                          </template>
                          <option
                            v-for="item in lstDemands"
                            :key="item.id"
                            :value="item.id"
                          >
                            {{ item.number }} - {{item.demand_type_name}}
                          </option>
                        </b-form-select>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col sm="6">
                      <b-form-group>
                        <label for="txtFechaEstudio">Fecha</label>
                        <b-form-input
                          type="date"
                          id="txtFechaEstudio"
                          v-model="caution.date"
                          :disabled="disabledCaution"
                          :max="maxDate"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>

                    <b-col sm="6">
                      <b-form-group>
                        <label for="cmbTipo">Tipo medida cautelar</label>
                        <b-form-select
                          v-model="caution.type"
                          id="cmbTipo"
                          :disabled="disabledCaution"
                        >
                          <template slot="first">
                            <option :value="null" disabled>
                              -- Seleccione el tipo --
                            </option>
                          </template>
                          <option
                            v-for="item in lstTypes"
                            :key="item.id"
                            :value="item.id"
                          >
                            {{ item.name }}
                          </option>
                        </b-form-select>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col>
                      <b-form-group>
                        <label for="cmbEstado">Estado</label>
                        <b-form-select
                          v-model="caution.status"
                          id="cmbEstado"
                          :disabled="disabledCaution"
                        >
                          <template slot="first">
                            <option :value="null" disabled>
                              -- Seleccione --
                            </option>
                          </template>
                          <option value="I">Pendiente</option>
                          <option value="P">Positiva</option>
                          <option value="N">Negativa</option>
                        </b-form-select>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <!-- INICIO CUENTA BANCARIA -->
                  <b-row v-if="caution.type == BANK_ACCOUNT">
                    <b-col>
                      <b-form-group>
                        <label for="cmbTipo">Banco</label>
                        <b-form-select
                          v-model="caution.bank_id"
                          id="cmbTipo"
                          :disabled="disabledCaution"
                        >
                          <template slot="first">
                            <option :value="null" disabled>
                              -- Seleccione el banco --
                            </option>
                          </template>
                          <option
                            v-for="item in lstBanks"
                            :key="item.id"
                            :value="item.id"
                          >
                            {{ item.name }}
                          </option>
                        </b-form-select>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <!-- FIN CUENTA BANCARIA -->

                  <!-- INICIO VEHICULO -->
                  <b-row v-if="caution.type == VEHICLE">
                    <b-col sm="6">
                      <b-form-group>
                        <label for="txtMarca">Marca</label>
                        <b-form-input
                          type="text"
                          id="txtMarca"
                          v-model="caution.brand"
                          :disabled="disabledCaution"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>
                    <b-col sm="6">
                      <b-form-group>
                        <label for="txtModelo">Modelo</label>
                        <b-form-input
                          type="text"
                          id="txtModelo"
                          v-model="caution.model"
                          :disabled="disabledCaution"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <b-row v-if="caution.type == VEHICLE">
                    <b-col>
                      <b-form-group>
                        <label for="txtLinea">Linea</label>
                        <b-form-input
                          type="text"
                          id="txtLinea"
                          v-model="caution.line"
                          :disabled="disabledCaution"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <!-- FIN VEHICULO -->

                  <!-- INICIO INMUEBLE -->
                  <b-row v-if="caution.type == PROPERTY">
                    <b-col>
                      <b-form-group>
                        <label for="cmbTipoInmueble">Tipo inmueble</label>
                        <b-form-select
                          v-model="caution.property_type_id"
                          id="cmbTipoInmueble"
                          :disabled="disabledCaution"
                        >
                          <template slot="first">
                            <option :value="null" disabled>
                              -- Seleccione el tipo --
                            </option>
                          </template>
                          <option
                            v-for="item in lstPropertyTypes"
                            :key="item.id"
                            :value="item.id"
                          >
                            {{ item.name }}
                          </option>
                        </b-form-select>
                      </b-form-group>
                    </b-col>
                    <b-col sm="6">
                      <b-form-group>
                        <label for="txtNumeroMatricula">Número matricula</label>
                        <b-form-input
                          type="text"
                          id="txtNumeroMatricula"
                          v-model="caution.registration_number"
                          :disabled="disabledCaution"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row v-if="caution.type == PROPERTY">
                    <b-col>
                      <b-form-group>
                        <label for="txtDireccion">Dirección</label>
                        <b-form-input
                          type="text"
                          id="txtDireccion"
                          v-model="caution.address"
                          :disabled="disabledCaution"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <!-- FIN INMUEBLE -->

                  <!-- INICIO ESTABLECIMIENTO DE COMERCIO -->
                  <b-row v-if="caution.type == TRADE_ESTABLISHMENT">
                    <b-col sm="6">
                      <b-form-group>
                        <label for="txtNombre">Nombre</label>
                        <b-form-input
                          type="text"
                          id="txtNombre"
                          v-model="caution.name"
                          :disabled="disabledCaution"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>
                    <b-col sm="6">
                      <b-form-group>
                        <label for="txtNumeroMatricula">Número matricula</label>
                        <b-form-input
                          type="text"
                          id="txtNumeroMatricula"
                          v-model="caution.registration_number"
                          :disabled="disabledCaution"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <b-row v-if="caution.type == TRADE_ESTABLISHMENT">
                    <b-col>
                      <b-form-group>
                        <label for="txtDireccion">Dirección</label>
                        <b-form-input
                          type="text"
                          id="txtDireccion"
                          v-model="caution.address"
                          :disabled="disabledCaution"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <!-- FIN ESTABLECIMIENTO DE COMERCIO -->

                  <!-- INICIO SALARIO O CONTRATOS -->

                  <b-row
                    v-if="caution.type == SALARY || caution.type == CONTRACTS"
                  >
                    <b-col>
                      <b-form-group>
                        <label for="txtEntidad">Entidad</label>
                        <b-form-input
                          type="text"
                          id="txtEntidad"
                          v-model="caution.entity"
                          :disabled="disabledCaution"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <!-- FIN SALARIO O CONTRATOS -->

                  <b-row class="mt-2">
                    <b-col sm="12">
                      <b-form-group>
                        <label for="txtComentario">Comentario</label>
                        <b-form-textarea
                          rows="4"
                          id="txtComentario"
                          no-resize
                          v-model="caution.description"
                          :disabled="disabledCaution"
                        ></b-form-textarea>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <b-row v-if="!disabledCaution">
                    <b-col sm="4" class="center-block">
                      <b-button
                        type="submit"
                        variant="success"
                        class="btn-sm col-sm-12"
                        :disabled="disabledCaution"
                        >Guardar</b-button
                      >
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!-- FIN MODAL PARA EL FORMULARIO -->

    <!-- MODAL PARA LAS GESTIONES -->
    <div class="modal fade" id="dlgManagement">
      <div class="modal-dialog modal-dialog-centered modal-success modal-lg">
        <div class="modal-content">
          <!-- Modal Header -->
          <div class="modal-header">
            <h4 class="modal-title">GESTIÓN</h4>
            <button type="button" class="close" @click="closeTaskManagement()">
              &times;
            </button>
          </div>

          <!-- Modal body -->
          <div class="modal-body">
            <form
              @submit.prevent="updateManagement()"
              method="put"
              class="box-typical"
              v-if="management_edit.id"
            >
              <textarea
                type="text"
                class="write-something"
                rows="3"
                :placeholder="`- Ingresa tu gestión`"
                v-model="management_edit.management"
              ></textarea>

              <div class="box-typical-footer">
                <div class="tbl">
                  <div class="tbl-row">
                    <b-row>
                      <b-col sm="4">
                        <b-form-group>
                          <date-picker
                            name="date"
                            v-model="management_edit.date"
                            :config="options"
                            placeholder="Fecha"
                          ></date-picker>
                        </b-form-group>
                      </b-col>


                      <b-col sm="2">
                        <b-form-group>
                          <button type="submit" class="btn btn-success">
                            Enviar
                          </button>
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </div>
                </div>
              </div>
            </form>
            <!--.box-typical-->
          </div>
        </div>
      </div>
    </div>
    <!-- FIN MODAL PARA LAS GESTIONES -->
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: "Caution",
  props: {
    debtor_id: {
      type: String,
      default: null,
    },
  },
  data: () => {
    return {
      token: localStorage.getItem("token"),
      isAdmin: localStorage.getItem("auth_is_admin") === "S" ? true : false,
      role_id: localStorage.getItem("role_id"), // PARA DETERMINAR EL ROL DEL USUARIO QUE INGRESA
      maxDate: moment(String(new Date())).format("YYYY-MM-DD"),
      options: {
        // https://momentjs.com/docs/#/displaying/
        format: "DD/MM/YYYY h:mm A",
        useCurrent: true,
        showClear: true,
        showClose: true,
        // minDate: moment().subtract(2, "d"),
        maxDate: moment(),
      },
      // CABECERAS PARA LA TABLA
      fields: [
        {
          key: "selected",
          sortable: false,
          label: "",
          class: "options-column",
        },

        { key: "demand_number", label: "Demanda" },
        { key: "type_name", label: "Tipo medida cautelar" },
        { key: "_caution_name", label: "Detalle" },
        { key: "date", label: "Fecha" },
        { key: "status_name", label: "Estado" },
        { key: "created_at", label: "Fecha cargue" },
        { key: "user_name", label: "Creado por" },
        { key: "actions", label: "Opciones" },
      ],
      laravelData: {},
      laravelDataManagements: {},
      lstCautions: [],
      lstTypes: [],
      lstBanks: [],
      lstPropertyTypes: [],
      isEdit: false,
      disabled: false,
      datos: [],
      errores: [],
      isEditCaution: false,
      disabledCaution: false,
      cautionSelected: { id: null },
      caution: {
        caution_name: null,
        demand_id: null,
        date: null,
        type: null,
        status: null,
        bank_id: null,
        debtor_id: null,
        property_type_id: null,
        brand: null,
        model: null,
        line: null,
        registration_number: null,
        name: null,
        address: null,
        entity: null,
        description: null,
        user_id: null,
      },
      management: {
        date: null,
        caution_id: null,
        management: null,
      },
      management_edit: {},
      lstManagements: [],
      lstDemands: [],

      // ------------------------------------------------------------------------
      // VARIABLES PARA LA GESTÓN DE LAS ACCIONES Y PERMISOS DE CADA USUARIO
      // ------------------------------------------------------------------------
      CREATE: false,
      READ: false,
      UPDATE: false,
      DELETE: false,
      // ------------------------------------------------------------------------
      // VARIABLES PARA DETERMINAR EL FORMULRARIO A DILIGENCIAR
      // ------------------------------------------------------------------------
      BANK_ACCOUNT: 140,
      VEHICLE: 141,
      PROPERTY: 142,
      TRADE_ESTABLISHMENT: 143,
      SALARY: 144,
      CONTRACTS: 145,
    };
  },
  created() {
    this.enabledActions();
    this.getCautions();
  },

  methods: {
    enabledActions() {
      var auth = localStorage.getItem("auth");
      auth = JSON.parse(auth)[0];
      this.CREATE = auth.create == 1;
      this.READ = auth.read == 1;
      this.UPDATE = auth.update == 1;
      this.DELETE = auth.delete == 1;
    },
    initParameters() {
      this.caution.debtor_id = this.debtor_id;
      this.caution.caution_name= null;
      this.caution.demand_id = null;
      this.caution.type = null;
      this.caution.status = null;
      this.caution.bank_id = null;
      this.caution.property_type_id = null;
      this.caution.brand = null;
      this.caution.model = null;
      this.caution.line = null;
      this.caution.registration_number = null;
      this.caution.name = null;
      this.caution.address = null;
      this.caution.entity = null;
      this.caution.description = null;
      this.caution.user_id = null;

      // CARGAR EL LISTADO DE DEMANDAS
      this.$http.get(`${this.$urlApi}demands/debtor/${this.debtor_id}?token=${this.token}`).then(
        (response) => {
          this.lstDemands = response.data.data;
        },
        (error) => {
          console.log(error);
          this.errores = getMsgError(error);
        }
      );

      // 24: TIPOS DE MEDIDAS CAUTELARES
      this.$http.get(`${this.$urlApi}parameters/24?token=${this.token}`).then(
        (response) => {
          this.lstTypes = response.data.data;
        },
        (error) => {
          console.log(error);
        }
      );

      // 25: LISTA DE BANCOS
      this.$http.get(`${this.$urlApi}parameters/25?token=${this.token}`).then(
        (response) => {
          this.lstBanks = response.data.data;
        },
        (error) => {
          console.log(error);
        }
      );

      // 26: TIPO DE INMUEBLE
      this.$http.get(`${this.$urlApi}parameters/26?token=${this.token}`).then(
        (response) => {
          this.lstPropertyTypes = response.data.data;
        },
        (error) => {
          console.log(error);
        }
      );
    },
    getCautions: function (page = 1) {
      showLoader();

      this.lstManagements = [];
      this.laravelData = {};

      // ARMAR LA URL CON LA PAGINACIÓN
      let url = `${this.$urlApi}cautions/debtor/${this.debtor_id}?token=${this.token}&page=${page}`;

      this.$http
        .get(url, {
          headers: { "Content-Type": "application/json" },
        })
        .then(
          function (response) {
            console.log(response);

            this.lstCautions = response.data.data.data;
            this.laravelData = response.data.data;

            // this.pagination = setPaginator(response.data.data);
            hideLoader();
          },
          (error) => {
            console.log(error);
            hideLoader();
          }
        );
    },
    getManagements: function (page = 1) {
      showLoader();

      this.lstManagements = [];
      this.laravelDataManagements = {};

      // ARMAR LA URL CON LA PAGINACIÓN
      let url = `${this.$urlApi}cautionmanagements/caution/${this.cautionSelected.id}?token=${this.token}&page=${page}`;

      this.$http
        .get(url, this.auth, {
          headers: { "Content-Type": "application/json" },
        })
        .then(
          function (response) {
            console.log(response);

            this.lstManagements = response.data.data.data;
            this.laravelDataManagements = response.data.data;
            hideLoader();
          },
          (error) => {
            console.log(error);
            hideLoader();
          }
        );
    },
    formatDate(value) {
      return moment(String(value)).format("DD/MM/YYYY");
    },
    addCaution() {
      this.errores = [];
      $("#dlgCaution").modal({ backdrop: "static", keyboard: false }); // EVITA QUE SE CIERRE EL MODAL AL DAR CLIC FUERA DE EL
      this.isEditCaution = false;
      this.initParameters();
      $("#dlgCaution").modal("show");
    },
    editCaution(item) {
      this.errores = [];
      this.initParameters();
      $("#dlgCaution").modal({ backdrop: "static", keyboard: false }); // EVITA QUE SE CIERRE EL MODAL AL DAR CLIC FUERA DE EL
      this.caution = Object.assign({}, item);
      this.isEditCaution = true;
      $("#dlgCaution").modal("show");
    },
    viewCaution(item) {
      this.errores = [];
      this.initParameters();
      $("#dlgCaution").modal({ backdrop: "static", keyboard: false }); // EVITA QUE SE CIERRE EL MODAL AL DAR CLIC FUERA DE EL
      this.caution = Object.assign({}, item);
      this.disabledCaution = true;
      $("#dlgCaution").modal("show");
    },
    saveCaution() {
      this.errores = [];
      if (this.isEditCaution) {
        this.updateCaution();
      } else {
        this.$swal({
          title: "Guardar",
          text: "¿Está seguro que toda la información ingresada es correcta?",
          type: "question",
          showCancelButton: true,
          cancelButtonText: "Volver",
          confirmButtonText: "Si",
        }).then((result) => {
          if (result.value) {
            this.createCaution();
          }
        });
      }
    },
    createCaution() {
      showLoader();
      let datos = JSON.stringify(this.caution);

      this.$http
        .post(`${this.$urlApi}cautions?token=${this.token}`, datos, {
          headers: { "Content-Type": "application/json" },
        })
        .then(function (response) {
          //console.log(response)

          hideLoader();

          this.$swal({
            title: "Buen trabajo",
            text: "Medida cautelar guardada correctamente!",
            type: "success",
            showCancelButton: false,
            confirmButtonText: "Aceptar",
          }).then((result) => {
            if (result.value) {
              // CERRAR EL MODAL Y LISTAR EL ESTUDIO GUARDADO
              this.caution.debtor_id = null;
              this.getCautions();
              $("#dlgCaution").modal("hide");
            }
          });
        })
        .catch((error) => {
          console.log(error);
          this.errores = getMsgError(error);
          hideLoader();
        });
    },
    updateCaution() {
      showLoader();
      let datos = JSON.stringify(this.caution);

      this.$http
        .put(
          `${this.$urlApi}cautions/${this.caution.id}?token=${this.token}`,
          datos,
          { headers: { "Content-Type": "application/json" } }
        )
        .then(function (response) {
          //console.log(response)

          hideLoader();

          this.$swal({
            title: "Buen trabajo",
            text: "Medida cautelar actualizado correctamente!",
            type: "success",
            showCancelButton: false,
            confirmButtonText: "Aceptar",
          }).then((result) => {
            if (result.value) {
              // CERRAR EL MODAL Y LISTAR EL ESTUDIO GUARDADO
              this.caution.debtor_id = null;
              this.getCautions();
              $("#dlgCaution").modal("hide");
            }
          });
        })
        .catch((error) => {
          console.log(error);
          this.errores = getMsgError(error);
          hideLoader();
        });
    },
    deleteCaution(item) {
      this.$swal({
        title: "Eliminar",
        text: "Desea eliminar el estudio de bienes ?",
        type: "question",
        showCancelButton: true,
        cancelButtonText: "Cancelar",
        confirmButtonText: "Aceptar",
      }).then((result) => {
        if (result.value) {
          showLoader();
          this.$http
            .delete(`${this.$urlApi}cautions/${item.id}?token=${this.token}`, {
              headers: { "Content-Type": "application/json" },
            })
            .then(function (response) {
              console.log(response);
              hideLoader();

              this.$swal({
                title: "Buen trabajo",
                text: "Medida cautelar eliminado correctamente!",
                type: "success",
                showCancelButton: false,
                confirmButtonText: "Aceptar",
              }).then((result) => {
                if (result.value) {
                  this.getCautions();
                }
              });
            })
            .catch((error) => {
              console.log(error);
              hideLoader();
            });
        }
      });
    },
    closeCaution() {
      this.isEditCaution = false;
      this.disabledCaution = false;
      $("#dlgCaution").modal("hide");
    },
    onRowSelected(cautions) {
      if(this.role_id == 6) return false;
      showLoader();
      this.cautionSelected = { id: null };
      console.log("onRowSelected");
      // this.cautionSelected = cautions[0];

      setTimeout(() => {
        this.cautionSelected = cautions[0];
        console.log("cautionSelected => ", this.cautionSelected);
        if(this.cautionSelected) this.getManagements();

        hideLoader();
      }, 100);

      // LLAMAR AL OTRO COMPONENTE DE GESTIONES Y PASARLE ID DE LA DEMANDA
    },

    saveManagement() {
      showLoader();

      this.management.caution_id = this.cautionSelected.id;
      let data = JSON.stringify(this.management);

      this.$http
        .post(
          `${this.$urlApi}cautionmanagements?token=${this.token}`,
          data,
          {
            headers: { "Content-Type": "application/json" },
          }
        )
        .then(function (response) {
          // console.log(response)

          hideLoader();

          this.$swal({
            title: "Buen trabajo",
            text: "Gestión guardada correctamente!",
            type: "success",
            showCancelButton: false,
            confirmButtonText: "Aceptar",
          }).then((result) => {
            if (result.value) {
              this.management = {
                date: null,
                type: null,
                demand_id: null,
                management: null,
                privacy: null,
              };
              this.lstFiles = [];
              this.getManagements();
            }
          });
        })
        .catch((error) => {
          console.log(error);
          this.errores = getMsgError(error);
          hideLoader();
        });
    },
    deleteManagement(management) {
      // VALIDAR SI ES UN COMERCIAL Y SI PUEDE ELIMINAR
      if (!this.role_id == 1) {
        var auth = localStorage.getItem("auth");
        auth = JSON.parse(auth);
        var user_id = auth[0].id;

        if (management.user_id != user_id) {
          this.$swal({
            title: "Advertencia",
            text: "La gestión no se puede eliminar, fue creada por otro usuario!",
            type: "warning",
            showCancelButton: false,
            confirmButtonText: "Aceptar",
          });
          return false;
        }

        // VERIFICAR EL TIEMPO TRANSCURRIDO
        var fechaGestion = moment(
          management._created_at,
          "YYYY-MM-DD HH:mm:ss"
        );
        var fechaActual = moment(new Date(), "YYYY-MM-DD HH:mm:ss");
        var dias = fechaActual.diff(fechaGestion, "days");
        var minutos = fechaActual.diff(fechaGestion, "m");

        if (dias > 0 || minutos > 10) {
          this.$swal({
            title: "Oops...",
            text: "La gestión ya superó los 10 minutos para ser eliminada, contacte con el administrador.",
            type: "error",
            showCancelButton: false,
            confirmButtonText: "Aceptar",
          });
          return false;
        }
      }

      this.$swal({
        title: "Eliminar",
        text: "Desea eliminar la gestión ?",
        type: "question",
        showCancelButton: true,
        cancelButtonText: "Cancelar",
        confirmButtonText: "Aceptar",
      }).then((result) => {
        if (result.value) {
          showLoader();
          this.$http
            .delete(
              `${this.$urlApi}cautionmanagements/${management.id}?token=${this.token}`,
              { headers: { "Content-Type": "application/json" } }
            )
            .then(function (response) {
              //console.log(response)
              hideLoader();

              this.$swal({
                title: "Buen trabajo",
                text: "Gestión eliminada correctamente!",
                type: "success",
                showCancelButton: false,
                confirmButtonText: "Aceptar",
              }).then((result) => {
                if (result.value) {
                  this.getManagements();
                }
              });
            })
            .catch((error) => {
              console.log(error);
              hideLoader();
            });
        }
      });
    },
    editManagement(management) {
      this.files = [];

      // VALIDAR SI ES UN COMERCIAL Y SI PUEDE EDITAR
      if (!this.role_id == 1) {
        // VERIFICAR EL TIEMPO TRANSCURRIDO
        var fechaGestion = moment(
          management._created_at,
          "YYYY-MM-DD HH:mm:ss"
        );
        var fechaActual = moment(new Date(), "YYYY-MM-DD HH:mm:ss");
        var dias = fechaActual.diff(fechaGestion, "days");
        var minutos = fechaActual.diff(fechaGestion, "m");

        if (dias > 0 || minutos > 10) {
          this.$swal({
            title: "Oops...",
            text: "La gestión ya superó los 10 minutos para ser editada, contacte con el administrador.",
            type: "error",
            showCancelButton: false,
            confirmButtonText: "Aceptar",
          });
          return false;
        }
      }

      this.errores = [];
      $("#dlgManagement").modal({ backdrop: "static", keyboard: false }); // EVITA QUE SE CIERRE EL MODAL AL DAR CLIC FUERA DE EL
      this.management_edit = Object.assign({}, management);
      $("#dlgManagement").modal("show");
    },
    updateManagement() {
      showLoader();
      this.management_edit.caution_id = this.cautionSelected.id;
      let data = JSON.stringify(this.management_edit);

      this.$http
        .put(
          `${this.$urlApi}cautionmanagements/${this.management_edit.id}?token=${this.token}`,
          data,
          { headers: { "Content-Type": "application/json" } }
        )
        .then(function (response) {
          //console.log(response)
          hideLoader();

          this.$swal({
            title: "Buen trabajo",
            text: "Gestión actualizada correctamente!",
            type: "success",
            showCancelButton: false,
            confirmButtonText: "Aceptar",
          }).then((result) => {
            if (result.value) {
              this.management_edit = {};
              this.lstFiles = [];
              this.getManagements();
              $("#dlgManagement").modal("hide");
            }
          });
        })
        .catch((error) => {
          console.log(error);
          this.errores = getMsgError(error);
          hideLoader();
        });
    },
    closeTaskManagement() {
      this.management_edit = {
        date: null,
        caution_id: null,
        management: null,
      };
      $("#dlgManagement").modal("hide");
    },
  },
};
</script>
